export const PERMS = {
    READ: 'report_vehicle_checks.read',
    UPDATE: 'report_vehicle_checks.update',
    DELETE: 'report_vehicle_checks.delete',
    CREATE: 'report_vehicle_checks.create',
}
